module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Dados da Maquininha","serialNumber":"Número de série","status":"Status","model":"Modelo","type":"Tipo","connection":"Conexão"},"en-US":{"title":"Terminal Data","serialNumber":"Serial number","status":"Status","model":"Model","type":"Type","connection":"Connection"}}')
  delete Component.options._Ctor
}
